import type { SupabaseClient } from '@supabase/supabase-js';
import type {
  DomainSyncJob,
  IDomainSyncRepository,
} from '../../../interfaces/src';

export class SupabaseDomainSyncRepository implements IDomainSyncRepository {
  constructor(private supabase: SupabaseClient) {}

  async listPending(): Promise<DomainSyncJob[]> {
    const { data, error } = await this.supabase.rpc('list_pending_domain_syncs');
    if (error || !data) return [];
    type Row = {
      hostname: string;
      attempt: number;
      last_error: string | null;
      created_at: string;
      updated_at: string;
    };
    return (data as Row[]).map((r) => ({
      hostname: r.hostname,
      attempt: r.attempt,
      lastError: r.last_error,
      createdAt: r.created_at,
      updatedAt: r.updated_at,
    }));
  }
}
